import { BreadcrumbComponent, CIPageHeader } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import classes from './SourcesWrapper.module.scss';
import SourceList from './source-registry/source-list/SourceList';

const RegistriesWrapper = () => {
  const { t: translate } = useTranslation();
  return (
    <div className={classes['registry-container']}>
      <BreadcrumbComponent />
      <div className={classes['registry-title-styling']} data-testid="tabKey-Source-Topic-Registry">
        <CIPageHeader header={translate('registriesWrapper.registriesHeader')} />
      </div>
      <div className={classes['registry-apptab']}>
        <SourceList />
      </div>
    </div>);
};

export default RegistriesWrapper;
